//import { css } from "@emotion/react"
import DOMPurify from "dompurify";

type SafeHtmlContentProps = {
	htmlContent?: string;
};
export const SafeHtmlContent: React.FC<SafeHtmlContentProps> = (props) => {
	//css={css`all:initial;color:unset;`}
	return (
		<>
			{props.htmlContent && (
				<div
					className="content user-content"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Using DOMPurify to support user generated content
					dangerouslySetInnerHTML={{
						__html: DOMPurify.sanitize(props.htmlContent),
					}}
				></div>
			)}
		</>
	);
};
